import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetDeclaracionJuradaViolenciaGeneroByID = {
  status: number | null;
  statusText: string | null;
};

const useGetDeclaracionJuradaViolenciaGeneroByID = () => {
  const [loadingGetDeclaracionJuradaViolenciaGeneroByID, setLoadingDeclaracionJuradaViolenciaGeneroByID] = useState(false);
  const [successGetDeclaracionJuradaViolenciaGeneroByID, setSuccessDeclaracionJuradaViolenciaGeneroByID] = useState(false);
  const [errorGetDeclaracionJuradaViolenciaGeneroByID, setErrorDeclaracionJuradaViolenciaGeneroByID] = useState<any>(null);
  const [dataGetDeclaracionJuradaViolenciaGeneroByID, setDataDeclaracionJuradaViolenciaGenero] = useState<any>(null);

  const [statusGetDeclaracionJuradaViolenciaGeneroByID, setStatusGetDeclaracionJuradaViolenciaGeneroByID] =
    useState<StatusGetDeclaracionJuradaViolenciaGeneroByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getDeclaracionJuradaViolenciaGeneroByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingDeclaracionJuradaViolenciaGeneroByID(true);
    setSuccessDeclaracionJuradaViolenciaGeneroByID(false);
    setErrorDeclaracionJuradaViolenciaGeneroByID(null);

    try {
      const res = await apiRecord.getSolicitudDeclaracionJuradaFuerzaMayorByID(userId, prestacionId, id);

      setStatusGetDeclaracionJuradaViolenciaGeneroByID({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessDeclaracionJuradaViolenciaGeneroByID(true);
      setDataDeclaracionJuradaViolenciaGenero(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetDeclaracionJuradaViolenciaGeneroByID({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetDeclaracionJuradaViolenciaGeneroByID(err);
      console.error("Error en getDeclaracionJuradaViolenciaGeneroByID:", err);

      throw err;

    } finally {
      setLoadingDeclaracionJuradaViolenciaGeneroByID(false);
    }
  };

  return {
    getDeclaracionJuradaViolenciaGeneroByID,
    loadingGetDeclaracionJuradaViolenciaGeneroByID,
    successGetDeclaracionJuradaViolenciaGeneroByID,
    errorGetDeclaracionJuradaViolenciaGeneroByID,
    dataGetDeclaracionJuradaViolenciaGeneroByID,
    statusGetDeclaracionJuradaViolenciaGeneroByID
  };
};

export default useGetDeclaracionJuradaViolenciaGeneroByID;
